import { createFileRoute, Outlet } from "@tanstack/react-router";

// Posts (#728): a layout route, not a page of its own — same pattern as
// `developer.tsx`/`sending.tsx`. `posts.tsx`, not `_posts.tsx`, so `/posts`
// stays a real segment its children nest under rather than a pathless layout
// contributing none. `posts/index.tsx` renders the list (moved here unchanged
// from this file's old direct component); `posts/new.tsx` is New post's own
// canonical route, a sibling rather than transient `?new=true` state under
// the list (see
// `goodsender-autopilot/specs/728-dashboard-nav-reorg/DECISIONS.md` D-728-7).
//
// `component: Outlet`, not `() => <Outlet />`: the inline arrow is anonymous
// in React DevTools and in error-boundary stacks. `developer.tsx`/`sending.tsx`
// name the same component, and `dashboard-route-parity.test.tsx` pins the
// identity for all three.
export const Route = createFileRoute("/dashboard/w/$workspaceId/posts")({
  component: Outlet,
});
